'use client';
import { datadogRum } from '@datadog/browser-rum';
import { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import { useAnalytics } from '../../Analytics';

export type AnonymousId = string | null | undefined;

const AnonymousIdContext = createContext<AnonymousId>(null);

export function AnonymousIdProvider({ children }: PropsWithChildren) {
  const { analytics } = useAnalytics();
  const [anonymousId, setAnonymousId] = useState<AnonymousId>(null);

  useEffect(() => {
    void analytics?.segmentInstance?.ready(async () => {
      const user = await analytics?.segmentInstance?.user();
      if (user) {
        setAnonymousId(user.anonymousId());
        datadogRum.setUserProperty('anonymous_id', user.anonymousId());
      }
    });
  }, []);
  return <AnonymousIdContext.Provider value={anonymousId}>{children}</AnonymousIdContext.Provider>;
}

export function useAnonymousId() {
  const context = useContext(AnonymousIdContext);
  if (context === undefined) {
    throw new Error('useAnonymousId must be used within a AnonymousIdProvider');
  }
  return context;
}
